export class NumberFormatUtils {
  static format(value: number | null, formatter: Intl.NumberFormat): string {
    if (value === null) {
      return "";
    }
    return formatter.format(value);
  }
}
